import http from './http';

export default {
  // 获取机构列表
  getOrganizerList(params) {
    return http.get('/o1/organizer', { params });
  },
  
  // 获取机构详情
  getOrganizerDetail(organizerId) {
    return http.get(`/o1/organizer/read?id=${organizerId}`);
  },
  
  // 获取当前机构信息
  getCurrentOrganizer() {
    return http.get('/o1/organizer/current');
  },
  
  // 创建机构
  createOrganizer(data) {
    return http.post('/o1/organizer/save', data);
  },
  
  // 更新机构信息
  updateOrganizer(organizerId, data) {
    return http.post(`/o1/organizer/update?id=${organizerId}`, data);
  },
  
  // 更新当前机构信息
  updateCurrentOrganizer(data) {
    return http.post('/o1/organizer/updateCurrent', data);
  },
  
  // 删除机构
  deleteOrganizer(organizerId) {
    return http.delete(`/o1/organizer/delete?id=${organizerId}`);
  },
  
  // 获取主题配置
  getThemeConfig() {
    return http.get('/o1/organizer/getThemeConfig');
  },
  
  // 更新主题配置
  updateThemeConfig(themeConfig) {
    return http.post('/o1/organizer/updateThemeConfig', { theme_config: themeConfig });
  },
  
  // 重置主题配置
  resetThemeConfig() {
    return http.post('/o1/organizer/resetThemeConfig');
  },
  
  // 获取预设主题列表
  getPresetThemes() {
    return http.get('/o1/organizer/getPresetThemes');
  },
  
  // 获取机构统计数据
  getOrganizerStats() {
    return http.get('/o1/organizer/stats');
  }
};
